@if (visible) {
  <footer [ngClass]="cssClassName">
    @if (!!text) {
      <p class="footer-text" markdown>{{ text }}</p>
    }
    <div (mouseenter)="showVersion()" (mouseleave)="hideVersion()"><a target="_blank"
      href="https://www.interverbumtech.com">Powered
    by {{ title }}</a></div>
    <div class="version" [ngStyle]="{'display': versionVisible ? 'inline-block' : 'none'}">{{versionStr}}</div>
  </footer>
}
